const getConfig = () => {
  return {
    baseURL: process.env.REACT_APP_BASE_URL,
    app: process.env.REACT_APP_NAME
  };
};

export default getConfig;
